var ya_counter_id = (typeof ya_counter_id === "undefined") ? null : ya_counter_id;

(function ($) 
{
	$.fn.animated_blocks = function(blocks) 
	{
		var wscroll = $(window).scrollTop();
		var wh = $(window).height();

		for(i = 0; i < blocks.length; i++)
		{
			var offset = (($('.animated-section').eq(i).outerHeight() / 3) < 400) ? ($('.animated-section').eq(i).outerHeight() / 3) : 400;
			if(blocks[i] <= wscroll + (wh - offset))
			{
				$('.animated-section').eq(i).find('img,div,p,.btn,a').each(function()							
				{
					if($(this).attr('data-effect'))
					{
						var delay = !$(this).attr('data-delay') ? '1s' : $(this).attr('data-delay');
						$(this)
						.addClass('animated')
						.addClass($(this).attr('data-effect'))
						.addClass('delay-' + delay)
						.removeClass('opacity-0')
						.removeAttr('data-effect');
					}
				});
			}
		}

		return;
	};

	$.fn.message = function (text) 
	{
		//$('.modal.fade.show').each(function () 
		//{
		//	var id = $(this).attr('id');

		//	$('#' + id).modal('hide');
		//});

		$('#messageMod .message').html(text);
		$('#messageMod').modal();

		return this;
	};

	$.fn.createSVG = function (selector) 
	{
		$(selector).each(function () {
			var $img = $(this);
			var imgID = $img.attr('id');
			var imgClass = $img.attr('class');
			var imgURL = $img.attr('src');

			$.get(imgURL, function (data) {
				// Get the SVG tag, ignore the rest
				var $svg = $(data).find('svg');

				// Add replaced image's ID to the new SVG
				if (typeof imgID !== 'undefined') {
					$svg = $svg.attr('id', imgID);
				}
				// Add replaced image's classes to the new SVG
				if (typeof imgClass !== 'undefined') {
					$svg = $svg.attr('class', imgClass + ' replaced-svg');
				}

				// Remove any invalid XML tags as per http://validator.w3.org
				$svg = $svg.removeAttr('xmlns:a');

				// Check if the viewport is set, else we gonna set it if we can.
				if (!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
					$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'));
				}

				// Replace image with new SVG
				$img.replaceWith($svg);
			}, 'xml');
		});

		return this;
	};

	$.fn.callbackOption = function (option, t) 
	{
		switch (option) 
		{
			case 'menu':
				$('#menuMod').modal();
				break;

			case 'toBlock':
				var block = t.attr('href');

				$('.modal.fade.show').each(function () 
				{
					var id = $(this).attr('id');

					$('#' + id).modal('hide');
				});

				var top = $(block).offset().top;

				if($(window).width() < 576)
					top = top - $('.sticky-top.top').outerHeight();

				$('html,body').animate(
				{
					scrollTop: top
				}, 1000);

				break;

			case 'form':
				$('#formMod').modal();

				var subject = t.attr('data-subject') ? t.attr('data-subject') : 'Новая заявка с сайта concept-studio.su';

				$('#formMod').find('#subject').val(subject);

				// var block = t.attr('data-for');
				// $('form[for="' + block + '"]').change();
				// ym(53917447, 'reachGoal', 'showProducts');
				break;

			default:
				$(window).message('<p class="h5 t-green"><b>Внимание</b></p><p class="small">JavaScript событие <mark>' + option + '</mark> не найдено Х-(<br />Обратитесь к разработчику</p>');
				break;
		}

		return this;
	};

})(jQuery);

$( window ).load(function()
{
	$('.carousel-nav').click(function(e)
	{
		e.preventDefault();

		var parent = $(this);



		do
		{
			parent = parent.parent();
		} while(!parent.hasClass('container') && !parent.hasClass('container-fluid'));

		if(parent.find('.carousel-items > div').length == 0)
			return false;

		if($(this).hasClass('next'))
		{
			var old_item = parent.find('.carousel-items > div:not(.d-none)');

			var j = 1;
			parent.find('.carousel-items > div').each(function()
			{
				if(!$(this).hasClass('d-none'))
					return false;
				
				j++;
			});

			if(parent.find('.carousel-items > div').length > j)
			{
				parent.find('.navigation').find('.dot.active').next().addClass('active').prev().removeClass('active');
				parent.find('.carousel-items > div:not(.d-none)').next().removeClass('d-none');
			}
			else
			{
				parent.find('.navigation').find('.dot.active').removeClass('active');
				parent.find('.navigation').find('.dot:first').addClass('active');
				parent.find('.carousel-items > div:first').removeClass('d-none');
			}

			old_item.addClass('d-none');
		}

		if($(this).hasClass('prev'))
		{
			var old_item = parent.find('.carousel-items > div:not(.d-none)');

			var j = 1;
			parent.find('.carousel-items > div').each(function()
			{
				if(!$(this).hasClass('d-none'))
					return false;
				
				j++;
			});

			if(j > 1)
			{
				parent.find('.navigation').find('.dot.active').prev().addClass('active').next().removeClass('active');
				parent.find('.carousel-items > div:not(.d-none)').prev().removeClass('d-none');
			}
			else
			{
				parent.find('.navigation').find('.dot.active').removeClass('active');
				parent.find('.navigation').find('.dot:last').addClass('active');
				parent.find('.carousel-items > div:last').removeClass('d-none');
			}

			old_item.addClass('d-none');
		}

		if($(this).hasClass('dot'))
		{
			parent.find('.carousel-items > div:not(.d-none)').addClass('d-none');
			var eq_index = parseInt($(this).attr('href'));
			parent.find('.carousel-items > div').eq(eq_index).removeClass('d-none');
			parent.find('.navigation').find('.dot.active').removeClass('active');
			$(this).addClass('active');
		}

		console.log(parent.attr('class'));
	});

	$('.tabs-nav-js').each(function()
	{
		var tabs_nav = $(this);
		var active_class = !$(this).attr('data-active-class') ? 'active' : $(this).attr('data-active-class');

		$('.tabs-nav-item', this).click(function(e)
		{
			e.preventDefault();

			var block_id = $(this).attr('href');
			

			var parent = $(this);

			do
			{
				parent = parent.parent();
			} while(!parent.hasClass('container') && !parent.hasClass('container-fluid'));

			parent.find('.tab-pane.active').removeClass('active');
			parent.find('.tab-pane' + block_id).addClass('active');

			parent.find('.tabs-nav-item.' + active_class).removeClass(active_class);
			$(this).addClass(active_class);

			var top = ($(this).offset().top > parent.find('.tab-pane' + block_id).offset().top) ? parent.find('.tab-pane' + block_id).offset().top : $(this).offset().top;

			if($(window).width() < 576)
				top = top - $('.sticky-top.top').outerHeight();

			$('html,body').animate(
			{
				scrollTop: top
			}, 1000);

			if($(this).parent().find('> span').length)
			{
				var width = $(this).outerWidth();
				var left = $(this).position().left - 4;
				if(left < 4)
					left = 4;
				$(this).parent().find('> span').width(width).css('left',left);
			}
		});

		if
		(
			tabs_nav.find('.tabs-nav-item.' + active_class).length && 
			tabs_nav.find('.tabs-nav-item.' + active_class).parent().find('> span').length
		)
		{
			var width = tabs_nav.find('.tabs-nav-item.' + active_class).outerWidth();
			var left = tabs_nav.find('.tabs-nav-item.' + active_class).position().left - 4;
			if(left < 4)
				left = 4;
			tabs_nav.find('.tabs-nav-item.' + active_class).parent().find('> span').width(width).css('left',left);
		}
	});

	$('[data-tag]').each(function()
	{
		var tag = $(this).attr('data-tag');
		var block = $(this);

		var pathTmp = '/inc/getInstaPosts.php?tag=' + tag;

		$.get(pathTmp).success(function(data)
		{ 
			if(block.find('.works-block').length)
			{
				block.find('.works-block a.d-inline-block').each(function(j)
				{
					if(data[j])
					{
						$(this).attr('href','https://www.instagram.com/p/' + data[j].code + '/').attr('target','_blank');
						$(this).find('img').attr('src',data[j].carousel_media[0].image_versions2.candidates[0].url);
					}
					else
						$(this).remove();
				});
			}
			
		});
	});

	var pathInstaPosts = '/inc/getInstaPosts.php';
	$.get(pathInstaPosts).success(function(data)
	{
		$('#portfolio #tab-1 .gallery .gallery-item').each(function(j)
		{
			if(data[j])
			{
				$(this).find('.img').css('background-image','url(' + data[j].carousel_media[0].image_versions2.candidates[0].url + ')');

				if(data[j].caption)
					$(this).find('p').html(data[j].caption.text);
				console.log(data[j]);
			}
			else
				$(this).remove();
		});
		for (var i = 0; i < data.length; i++) 
		{
			var html = '';
			var cl = i ? ' d-none' : '';

			html+=' <div class="row' + cl + ' align-items-center">';
			html+=' 	<div class="col-lg-3 mb-3">';
			html+=' 		<img src="' + data[i].carousel_media[0].image_versions2.candidates[0].url + '" class="img-fluid">';
			html+=' 	</div>';
			html+=' 	<div class="col-lg-9">';
			html+=' 		<p class="small">';
			html+=				data[i].caption.text;
			html+=' 		</p>';
			html+=' 	</div>';
			html+=' </div>';
			
			$('#design.carousel-items').append(html);
		}
	});

	var pathArticles = '/inc/getArticles.php';
	$.get(pathArticles).success(function(data)
	{
		$('#blog .container > .row:first .img-fluid').attr('src',data[0].image);
		$('#blog .container > .row:first .h6 b').text(data[0].title);
		$('#blog .container > .row:first .h6 + p').text(data[0].text);

		$('#blog .container > .row:first + .row').find('.col-lg-6').each(function(j)
		{
			var k = j + 1;

			$(this).find('.img-fluid').attr('src',data[k].image);
			$(this).find('.h6 b').text(data[k].title);
			$(this).find('.h6 + p').text(data[k].text);
			$(this).find('.h6 + p + p').text(data[k].date);
		});
	});

	$.getScript('/scripts/lightbox.min.js', function()
	{
		$('.fn').parent().each(function(index)
		{
			$(this).find('.fn').attr('data-lightbox','example-set');
		});
	});


	$.getScript('/scripts/bootstrap.min.js', function()
	{
		var blocks = new Array;

		$('.animated-section').each(function()
		{
			var x = $(this).offset().top;
			blocks.push(x);
		});

		$('body').on('click', '.call', function (e) 
		{
			e.preventDefault();

			var t = $(this);
			var option = !t.attr('data-option') ? 'form' : t.attr('data-option');

			$(window).callbackOption(option, t);
		});

		// $(window).message('test');

		// запуск анимации после загрузки страницы
		$(window).animated_blocks(blocks);

		// запуск анимации во время прокрутки
		$(window).on('scroll',function()
		{
			$(window).animated_blocks(blocks);
		});

		$('.gallery').each(function()
		{
			var gallery = $(this);

			$('.gallery-item', this).hover(function()
			{
				gallery.find('.gallery-item')
				.removeClass('col-lg-3')
				.removeClass('col-lg-6')
				.removeClass('active')
				.addClass('col-lg-2');

				$(this).addClass('col-lg-6').addClass('active');
			});
		});

		$('body').on('submit', 'form', function (e) 
		{
			var error = 0;
			var text = '';

			var form = $(this);

			$('.required:enabled,.r:enabled', this).each(function () 
			{
				if ($(this).attr('id') == 'agree' && !$(this).is(":checked")) {
					$(window).message('<p class="h5 t-green"><b>Внимание</b></p><p class="small">Для продолжения необходимо принять условия обработки персональных данных.</p>');
					error++;
				}
				if ($(this).val().length < 1) {
					var name = $(this).attr('name');
					var id = $(this).attr('id');

					if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';

					var tagname = $(this).prop("tagName");
					$(this).parent().addClass('has-error');
					if (tagname == 'SELECT') {
						var select_id = $(this).attr('id') + '_chosen';
						$('#' + select_id + '.chosen-container').addClass('invalid');
					}
					error++;
				} else if ($(this).attr('name').indexOf('phone') >= 0) {
					var val = $(this).val();

					val = val.replace(/[^0-9]/gim, '');

					if (val.length != 11) {
						error++;
						$(this).parent().addClass('has-error');
						if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
					} else $(this).parent().removeClass('has-error');
				} else if ($(this).attr('name').indexOf('mail') >= 0) {
					var val = $(this).val();

					var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

					if (!re.test(String(val).toLowerCase())) {
						error++;
						$(this).parent().addClass('has-error');
						if (form.find('label[for="' + name + '"]').length) text += '- <b>' + form.find('label[for="' + name + '"]').eq(0).text() + '</b><br />';else if (form.find('label[for="' + id + '"]').length) text += '- <b>' + form.find('label[for="' + id + '"]').eq(0).text() + '</b><br />';else if ($(this).attr('placeholder').length) text += '- <b>' + $(this).attr('placeholder') + '</b><br />';
					} else $(this).parent().removeClass('has-error');
				} else {
					var tagname = $(this).prop("tagName");
					$(this).parent().removeClass('has-error');
					if (tagname == 'SELECT') {
						var select_id = $(this).attr('id') + '_chosen';
						$('#' + select_id + '.chosen-container').removeClass('invalid');
					}
				}
			});

			if (error > 0) {
				if (text.length) {
					text = '<p class="h5 t-green"><b>Произошла ошибка</b></p><p class="small">Введенные вами данные не будут отправлены, так как не все обязательные поля были заполнены:</p><p>' + text + '</p>';
					$(window).message(text);
				}

				e.preventDefault();
			} else {
				var action = null;

				if ($(this).find('button[type="submit"]').length) action = $(this).find('button[type="submit"]').val();

				if ($('body').hasClass('checkout') || $('body').hasClass('profile_page') || action == 'register' || action == 'remind' || action == 'login' || $('body').hasClass('remind')) action = null;

				var form = $(this);

				if (action) {
					$('body').addClass('loading');

					e.preventDefault();

					$.ajax({
						type: 'POST',
						method: 'POST',
						cashe: false,
						url: '/send.php',
						data: { ajax: true, option: action, query: $(this).serialize() }
					}).done(function (msg) {
						$('body').removeClass('loading');

						form.find("input[type=text], textarea").val("");

						var text = msg;

						if (!msg) text = '<p class="h5 t-green"><b>Произошла ошибка</b></p><p class="small">Ваше сообщение не было отправлено. Попробуйте сделать это позже.</p>';

						if(form.attr('data-goal') && ya_counter_id)
							ym(ya_counter_id, 'reachGoal', form.attr('data-goal'));

						if (msg && msg == 1) 
						{
							$('.modal.fade.show').each(function () 
							{
								var id = $(this).attr('id');

								$('#' + id).modal('hide');
							});

							text = '<p class="h5 t-green"><b>Спасибо!</b></p><p class="small">Ваше сообщение было успешно отправлено. В ближайшее время с Вами свяжется наш менеджер для подтверждения заявки.</p>';
						}

						var message_text = $.trim(text);

						if (message_text.indexOf('h5') < 0) 
						{
							$('#form').addClass('invisible').removeClass('animated').removeClass('slideInUp');

							message_text = '<p class="h5 t-green"><b>Сообщение</b></p>' + message_text;
						}

						$(window).message(message_text);
					});
				}
			}
		});
	});
});


// WEBPACK FOOTER //
// ../scripts/sources/script.js